export class Utils {
  public static formatPhoneNumber(inputtext) {
    return inputtext.replace(/[^\d]/g, "");
  }

  public static validatePhoneNumber(inputtext) {
    if (
      Utils.phonenumber(inputtext) ||
      Utils.phoneWithPlus(inputtext) ||
      Utils.phoneWithBraces(inputtext)
    ) {
      return true;
    }
    return false;
  }

  public static phonenumber(inputtxt) {
    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    if (inputtxt.match(phoneno)) {
      return true;
    } else {
      return false;
    }
  }

  public static phoneWithPlus(inputtxt) {
    var phoneno = /^\+?([0-9]{2})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/;
    if (inputtxt.match(phoneno)) {
      return true;
    } else {
      return false;
    }
  }

  public static phoneWithBraces(inputtxt) {
    var phoneno = /^(\([0-9]{3}\)\s*|[0-9]{3}\-)[0-9]{3}-[0-9]{4}$/;
    if (inputtxt.match(phoneno)) {
      return true;
    } else {
      return false;
    }
  }

  public static getEnrollmentLink(zipcode, promocode, productid, term) {
    return `https://enroll.bkvenergy.com/Home/index?ZipCode=${zipcode}&ProductCode=${productid}&Term=${term}&Promo=SEOEIQ0001`;
  }

  public static getNewSignUpLink(zipcode, promocode, productid, term, Esiid) {
    // https://test-signupnew.bkvenergy.com/Home/index?ProductCode=RN00000161&Promo=PTC12CNPB&Term=12&Esiid=1008901001183619242100
    return `https://enroll.bkvenergy.com/Home/CustomerDetails?zipcode=${zipcode}&productcode=${productid}&term=${term}&promo=SEOEIQ0001&esiid=${Esiid}`;
  }
}
